import { Form, Input, App, Button } from 'antd'
import { useProfileContext } from '../../context/profile'
import { useEffect, useState } from 'react'
import { FormContainer, FormActions, StyledFormItem } from './styles/ProfileFormStyles'

interface ProfileFormValues {
  fullName: string
}

export function ProfileForm() {
  const { notification } = App.useApp()
  const { profile, updateProfile } = useProfileContext()
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (profile) {
      form.setFieldsValue({
        fullName: profile.full_name,
      })
    }
  }, [profile, form])

  const handleSubmit = async (values: ProfileFormValues) => {
    setLoading(true)
    const { error } = await updateProfile({
      full_name: values.fullName,
    })
    setLoading(false)

    if (error) {
      notification.error({
        title: 'Update Failed',
        description: (error as Error).message,
      })
    } else {
      notification.success({
        title: 'Profile Updated',
        description: 'Your profile has been updated successfully',
      })
    }
  }

  return (
    <FormContainer>
      <Form form={form} layout="vertical" onFinish={handleSubmit} requiredMark={false}>
        <StyledFormItem
          name="fullName"
          label="Full Name"
          rules={[{ required: true, message: 'Please enter your full name' }]}
        >
          <Input placeholder="Enter your full name" size="large" />
        </StyledFormItem>

        <FormActions>
          <Button type="primary" htmlType="submit" loading={loading}>
            Save Changes
          </Button>
        </FormActions>
      </Form>
    </FormContainer>
  )
}
